
import { defineComponent } from '@nuxtjs/composition-api'
import htmlBrandButton from '~/components/html/htmlBrandButton.vue'

export default defineComponent({
  props: ['title', 'link', 'linkText', 'imageUrl'],
  components: { htmlBrandButton },
  setup() {
    return {}
  },
})
